/**
 *  shop-details.serv.js
 */

class ShopDetailsServ {

    constructor($http, $q, $timeout, apiServ) {
        this.$http = $http;
        this.$q = $q;
        this.$timeout = $timeout;
        this.apiServ = apiServ;

        this.weekDays = ['Duminic&#259;', 'Luni', 'Mar&#539;i', 'Miercuri', 'Joi', 'Vineri', 'S&#226;mb&#259;t&#259;'];
    }

    getTodaysName() {
        var today = (new Date()).getDay();
        return this.weekDays[today];
    }

    getTodaysProgram(program) {
        var today = (new Date()).getDay();
        var keys = Object.keys(program);
        return program[keys[today]];
    }

    getDirectionsUrl(lat, lng) {
        lat = parseFloat(lat);
        lng = parseFloat(lng);
        var latLng = new google.maps.LatLng(lat, lng);
        return 'https://maps.google.ro?&daddr=' + latLng;
    }

    readShopDetails(pos) {
        return this.$http.get(this.apiServ.readUrl('shop') + '/' + pos);
    }

    readShopAppointment(pos) {
        return this.$http.get(this.apiServ.readUrl('appointment') + '/' + pos);
    }
}

ShopDetailsServ.$inject = ['$http', '$q', '$timeout', 'apiServ'];

export default ShopDetailsServ;
